// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__16Hzz","info":"UpdateTermsInfo_info__2JhHm"};